<script>
    import * as ze from "@axel669/zephyr"
    import asuid from "@axel669/asuid"
    import sort from "@axel669/array-sort"

    import Inventory, { newBag } from "./comp/inventory.svelte"

    import chars from "#client.state/chars"

    const createChar = (complete) => {
        if (complete !== true) {
            return
        }
        chars.data.push({
            name: newCharName.trim(),
            id: asuid(),
            bags: [
                newBag({
                    "name.$set": "On Hand",
                    "info.$set": "Stuff being carried by your character, like in their pockets",
                    "pos.$set": 0,
                })
            ],
        })
        chars.data.sort(
            sort.prop(".name", sort.natural)
        )
    }
    let newCharName = $state("")

    const test = (evt) => {
        console.log(evt)
        evt.preventDefault()
        evt.stopPropagation()
    }

    // const remove = ze.eventHandler$(
    //     (result, char) => {
    //         if (result !== true) {
    //             return
    //         }
    //         chars.data.splice(chars.data.indexOf(char), 1)
    //     }
    // )
    const remove = (char) => {
        if (char === null) {
            return
        }
        chars.data.splice(chars.data.indexOf(char), 1)
    }
</script>

<svelte:body use:ze.wsx={{"@@theme": "tron", "@@app": true}} />

<ze.Screen>
    <ze.Paper r="0px" card l!gap="8px" l!p="8px">
        {#snippet header()}
        <ze.Titlebar>
            {#snippet title()}
            <ze.Text title>
                D&D Inventory
            </ze.Text>
            {/snippet}

            {#snippet action()}
            <ze.Button r="0px" ground compact onclick={() => chars.data = []}>
                Clear
            </ze.Button>
            {/snippet}
        </ze.Titlebar>
        {/snippet}

        {#each chars.data as char, index (char.id)}
            <ze.Grid cols="1fr 40px" gap="4px" $elevate
            b="1px solid @primary" p="4px" r="4px"
            rows="48px">
                <ze.Text title>
                    {char.name}
                </ze.Text>

                <ze.EntryButton outline color="@secondary" onentry={remove}>
                    <ze.Icon name="moneybag" />
                    {#snippet modal()}
                        <Inventory bind:char={chars.data[index]} />
                    {/snippet}
                </ze.EntryButton>
            </ze.Grid>
        {/each}

        {#snippet footer()}
            <ze.Flex>
                <ze.EntryButton outline onentry={createChar} color="@secondary">
                    <ze.Icon name="plus" /> Char
                    {#snippet modal()}
                        <ze.Prompt
                            bind:value={newCharName}
                            initial=""
                            title="New Character"
                            message="Character Name"
                            okText="Create"
                        />
                    {/snippet}
                </ze.EntryButton>
            </ze.Flex>
        {/snippet}
    </ze.Paper>
</ze.Screen>
